import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Input,
  Row,
  Label,
  Card,
  CardBody,
  CustomInput,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import {
  AxiosAPI,
  getGroupID,
  setSelectedGroup,
} from '../../../../../../helpers/AxiosAPI';
import { gAPI_FormsList } from '../../../../../../constants/APIs';
import Select from 'react-select';
import CustomSelectInput from '../../../../../../components/common/CustomSelectInput';
export default function FormSetting({
  settings,
  saveIntegration,
  integrationProperties,
  lang,
  propertyId,
}) {
  const [requestNames, setRequestNames] = useState([]);
  const [formSetting, setformSetting] = useState({
    isEnabled: false,
    formList: [
      {
        toRequest: '',
        fromRequest: '',
        formIds: [],
      },
    ],
  });
  const [selectedOptions, setselectedOptions] = useState([]);
  const [forms, setForms] = useState([]);

  const handleFormsettingEnabled = (e) =>
    setformSetting({ ...formSetting, isEnabled: e });

  const handleMenuRequestName = (e) =>
    setformSetting({ ...formSetting, requestName: e.target.value });

  const handleForms = (e, index) => {
    let list = [...formSetting.formList];
    let obj = list.filter((f, i) => index === i);
    if (obj.length > 0) {
      let options = [...selectedOptions];
      if (options.filter((f, i) => index === i).length === 0) {
        options.push(e);
      } else {
        options[index] = e;
      }
      setselectedOptions(options);
      list[index].formIds = e.map((m) => m.value);
    }
    setformSetting({ ...formSetting, formList: list });
  };

  const handleFormsChange = (e, index) => {
    let list = [...formSetting.formList];

    list[index][e.target.name] = e.target.value;
    setformSetting({ ...formSetting, formList: list });
  };

  useEffect(() => {
    if (settings !== undefined && settings.apiConfigurations !== undefined) {
      if (settings.apiConfigurations.length > 0) {
        let lst = settings.apiConfigurations.map((m) => m.requestName);
        setRequestNames(lst);
      }
    }
    if (integrationProperties.length === 1) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_FormsList}?groupId=${getGroupID()}&propertyId=${propertyId}&lang=${lang}`,
      }).then((res) => {
        let formSettingList = {
          isEnabled: false,
          formList: [],
        };
        let lst = [];
        if (res.data.length > 0) {
          res.data.map((m) =>
            lst.push({ label: m.name, key: m.id, value: m.id })
          );
          if (settings !== undefined && settings.formSetting !== undefined) {
            formSettingList.isEnabled = settings.formSetting.isEnabled;
            let menuList = settings.formSetting?.formList;
            let options = [];
            if (menuList !== undefined && menuList.length > 0) {
              menuList.map((m) => {
                if (m.formIds !== undefined && m.formIds.length > 0) {
                  let optionList = [];
                  res.data.filter((f) => {
                    if (m.formIds.filter((i) => i === f.id).length > 0)
                      optionList.push({
                        label: f.name,
                        key: f.id,
                        value: f.id,
                      });
                  });
                  formSettingList.formList.push({
                    fromRequest: m.fromRequest,
                    toRequest: m.toRequest,
                    formIds: optionList.map((o) => o.value),
                  });
                  options.push(optionList);
                }
              });
            }
            setselectedOptions(options);
          }
          setForms(lst);
        } else {
          formSettingList.isEnabled = settings.formSetting.isEnabled;
          let menuList = settings.formSetting?.formList;
          let options = [];
          if (menuList !== undefined && menuList.length > 0) {
            menuList.map((m) => {
              formSettingList.formList.push({
                fromRequest: m.fromRequest,
                toRequest: m.toRequest,
                formIds: [],
              });
            });
            setForms(lst);
          }
        }
        setformSetting(formSettingList);
      });
    } else {
      let lst = [...forms];
      let options = [...selectedOptions];
      let formSettingList = {
        isEnabled: false,
        formList: [],
      };

      const formsData = integrationProperties.map((m) => {
        return AxiosAPI({
          methhod: 'get',
          url: `${gAPI_FormsList}?groupId=${getGroupID()}&propertyId=${m}&lang=${lang}`,
        }).then((res) => {
          if (res.data.length > 0) {
            res.data.map((m) =>
              lst.push({ label: m.name, key: m.id, value: m.id })
            );
          }
        });
      });
      Promise.all(formsData).then((res) => {
        if (settings !== undefined && settings.formSetting !== undefined) {
          formSettingList.isEnabled = settings.formSetting.isEnabled;
          let menuList = settings.formSetting?.formList;
          if (menuList !== undefined && menuList.length > 0) {
            menuList.map((m) => {
              if (m.formIds !== undefined && m.formIds.length > 0) {
                let optionList = [];
                lst.filter((f) => {
                  if (m.formIds.filter((i) => i === f.value).length > 0)
                    optionList.push({
                      label: f.label,
                      key: f.value,
                      value: f.value,
                    });
                });
                formSettingList.formList.push({
                  fromRequest: m.fromRequest,
                  toRequest: m.toRequest,
                  formIds: optionList.map((o) => o.value),
                });
                options.push(optionList);
              }
            });
          }
        }
        setForms(lst);
        setselectedOptions(options);
        setformSetting(formSettingList);
      });
    }
  }, [settings]);

  const addMenu = () => {
    let list = [...formSetting.formList];
    list.push({
      toRequest: '',
      fromRequest: '',
      formIds: [],
    });
    setformSetting({ ...formSetting, formList: list });
  };

  const handleSave = () => {
    saveIntegration({ formSetting: formSetting });
  };

  const removeMenu = (index) => {
    let list = [...formSetting.formList];
    list = list.filter((f, i) => index !== i);
    let options = [...selectedOptions];
    options = options.filter((f, i) => index !== i);
    setselectedOptions(options);
    setformSetting({ ...formSetting, formList: list });
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Form Integrations</h6>
          </div>
          <Separator className="mb-3" />
          <div className="row mt-1 ml-2 mb-3">
            <Colxx md="12" className="mb-2">
              <Switch
                className="agentswitch  custom-switch-primary custom-switch-small ml-2 float-right"
                checked={formSetting?.isEnabled}
                name="isEnabled"
                onChange={(e) => handleFormsettingEnabled(e)}
              />
            </Colxx>
            <Colxx md="12">
              <Row>
                {formSetting.formList !== undefined &&
                  formSetting.formList !== null &&
                  formSetting.formList.length > 0 && (
                    <Fragment>
                      {formSetting.formList.map((m, index) => (
                        <Fragment>
                          <Colxx md="12" className="mb-2">
                            <Row>
                              <Colxx md="12" className="mb-2">
                                <Label>Invoke API before Form Submission</Label>
                                <Input
                                  type="select"
                                  name="fromRequest"
                                  value={m?.fromRequest}
                                  onChange={(val) => {
                                    handleFormsChange(val, index);
                                  }}
                                >
                                  <option value="">
                                    Invoke API before Form Submission
                                  </option>
                                  {requestNames.map((r) => (
                                    <option value={r}>{r}</option>
                                  ))}
                                </Input>
                              </Colxx>
                              <Colxx md="12" className="mb-2">
                                <Label>Invoke API on Form Submission</Label>
                                <Input
                                  type="select"
                                  name="toRequest"
                                  value={m?.toRequest}
                                  onChange={(val) => {
                                    handleFormsChange(val, index);
                                  }}
                                >
                                  <option value="">
                                    Invoke API on Form Submission
                                  </option>
                                  {requestNames.map((r) => (
                                    <option value={r}>{r}</option>
                                  ))}
                                </Input>
                              </Colxx>
                              <Colxx md="12">
                                <Label>Forms</Label>
                                <Select
                                  isMulti={true}
                                  components={{ Input: CustomSelectInput }}
                                  className="react-select"
                                  classNamePrefix="react-select"
                                  name="form-field-name"
                                  options={forms}
                                  placeholder="Select Forms"
                                  value={
                                    selectedOptions.filter(
                                      (f, i) => i === index
                                    ).length > 0
                                      ? selectedOptions.filter(
                                        (f, i) => i === index
                                      )[0]
                                      : []
                                  }
                                  onChange={(val) => {
                                    handleForms(val, index);
                                  }}
                                />
                              </Colxx>
                              <Colxx md="12" className="text-right">
                                <Button
                                  onClick={() => removeMenu(index)}
                                  className="mt-4"
                                  color="danger"
                                  size="xs"
                                  outline
                                >
                                  -
                                </Button>
                              </Colxx>
                            </Row>
                          </Colxx>
                        </Fragment>
                      ))}
                    </Fragment>
                  )}

                <Colxx md="12" className="text-left">
                  <Button onClick={addMenu} color="primary" size="xs" outline>
                    {' '}
                    + Add Form Integration
                  </Button>
                </Colxx>
              </Row>
            </Colxx>
          </div>
          <Separator className="mb-2" />
          <Colxx md="12" className="text-center mb-2">
            <Button
              onClick={() => handleSave()}
              color="primary"
              size="xs"
              outline
            >
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
